import React from "react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  totalPages: totalPagesProp,
}) => {
  const totalPages =
    totalPagesProp || Math.ceil((totalItems || 0) / (itemsPerPage || 1));

  if (totalPages <= 1) return null; // hide if only 1 page

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [1];
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push("start-ellipsis");

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    if (end < totalPages - 1) pages.push("end-ellipsis");

    pages.push(totalPages);
    return pages;
  };

  const pageNumbers = getVisiblePages();

  return (
    <nav
      className="flex justify-center items-center gap-2 mt-8 mb-12 flex-wrap"
      aria-label="Pagination"
    >
      {/* Previous Button */}
      <button
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="min-w-10 px-4 py-2 rounded-full bg-white text-black border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm font-medium"
      >
        Prev
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((number) =>
        typeof number === "string" ? (
          <span
            key={number}
            className="w-10 h-10 flex items-center justify-center text-gray-500"
          >
            ...
          </span>
        ) : (
          <button
            key={number}
            onClick={() => onPageChange(number)}
            aria-current={number === currentPage ? "page" : undefined}
            className={`w-10 h-10 rounded-full font-semibold transition-colors duration-200 border text-sm ${
              number === currentPage
                ? "bg-black text-white border-black"
                : "bg-white text-black border-gray-300 hover:bg-gray-100"
            }`}
          >
            {number}
          </button>
        ),
      )}

      {/* Next Button */}
      <button
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        disabled={currentPage === totalPages}
        className="min-w-10 px-4 py-2 rounded-full bg-white text-black border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm font-medium"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
